/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Message_RoleInputs */

const tr_landing_genius_agent_message_role = /** @type {(inputs: Landing_Genius_Agent_Message_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`müşteri yanıtları`)
};

const en_landing_genius_agent_message_role = /** @type {(inputs: Landing_Genius_Agent_Message_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`customer replies`)
};

const de_landing_genius_agent_message_role = /** @type {(inputs: Landing_Genius_Agent_Message_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundenantworten`)
};

const ru_landing_genius_agent_message_role = /** @type {(inputs: Landing_Genius_Agent_Message_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ответы клиентам`)
};

/**
* | output |
* | --- |
* | "customer replies" |
*
* @param {Landing_Genius_Agent_Message_RoleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_message_role = /** @type {((inputs?: Landing_Genius_Agent_Message_RoleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Message_RoleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_message_role(inputs)
	if (locale === "de") return de_landing_genius_agent_message_role(inputs)
	if (locale === "ru") return ru_landing_genius_agent_message_role(inputs)
	return tr_landing_genius_agent_message_role(inputs)
});